const baseUrl = process.env.PUBLIC_URL;

const routeNames = {
	HOME: `${baseUrl}/`,
	LOGIN: `${baseUrl}/login`,
	SIGNUP: `${baseUrl}/signup`,
	EMAIL_VERIFICATION_PENDING: `${baseUrl}/email-verification-pending`,
	FORGOT_PASSWORD: `${baseUrl}/forgot-password`,
	VERIFY_CODE: `${baseUrl}/verify-code`,
	NEW_PASSWORD: `${baseUrl}/new-password`,
	DASHBOARD: `${baseUrl}/dashboard`,
	NOTIFICATIONS: `${baseUrl}/notifications`,
	ORDER: `${baseUrl}/order`,
	REQUEST_SERVICE: `${baseUrl}/request-service`,
	PROFILE: `${baseUrl}/profile`,
	GUIDES: `${baseUrl}/guides`,
	GUIDE_DETAILS: `${baseUrl}/guides/:guideId`,
	GUIDE_DETAILS_EDIT: `${baseUrl}/guides/:guideId/edit`,
	GUIDE_ADD: `${baseUrl}/guides/add`,
	HANDOVERS: `${baseUrl}/handovers`,
	HANDOVERS_ADD: `${baseUrl}/handovers/add`,
	HANDOVER_DETAILS: `${baseUrl}/handovers/:handoverId`,
	HANDOVER_DETAILS_EDIT: `${baseUrl}/handovers/:handoverId/edit`,
	HANDOVER_DEVICE_DETECTION_ADD: `${baseUrl}/handover-device-detection/add`,
	HANDOVER_DEVICE_DETECTION_DETAILS: `${baseUrl}/handover-device-detection/:jobId`,
	INSTALLED_PRODUCTS: `${baseUrl}/installed-products`, // deprecated, redirects to INSTALLED_DEVICES
	INSTALLED_DEVICES: `${baseUrl}/installed-devices`,
	INSTALLED_DEVICE_DETAILS: `${baseUrl}/installed-device/:deviceId`,
	INSTALLED_DEVICES_DETAILS: `${baseUrl}/installed-devices/:installedDevId`,
	INSTALLED_PRODUCTS_DETAILS: `${baseUrl}/installed-products/:installedDevId`, // deprecated for above
	SHOP_PRODUCTS_DETAILS: `${baseUrl}/shop-products/:productId`,
	AI_CHAT: `${baseUrl}/ai-chat`,
	CHECKOUT: `${baseUrl}/checkout`,
	ADMIN_DASHBOARD: `${baseUrl}/admin`,
	ADMIN_PRODUCTS: `${baseUrl}/admin-products`, // deprecated, redirects to ADMIN_DEVICES
	ADMIN_PRODUCTS_ADD: `${baseUrl}/admin-products/add`, // deprecated
	ADMIN_PRODUCTS_DETAILS: `${baseUrl}/admin-products/:productId`, // deprecated
	ADMIN_PRODUCTS_EDIT: `${baseUrl}/admin-products/:productId/edit`, // deprecated
	ADMIN_DEVICES: `${baseUrl}/admin-devices`,
	ADMIN_DEVICES_ADD: `${baseUrl}/admin-devices/add`,
	ADMIN_DEVICES_DETAILS: `${baseUrl}/admin-devices/:deviceId`,
	ADMIN_DEVICES_EDIT: `${baseUrl}/admin-devices/:deviceId/edit`,
	ADMIN_USERS: `${baseUrl}/admin-users`,
	ADMIN_USER_ADD: `${baseUrl}/admin-user/add`,
	ADMIN_USER_DETAILS: `${baseUrl}/admin-user/:userId`,
	ADMIN_USER_EDIT: `${baseUrl}/admin-user/:userId/edit`,
	ADMIN_ORGANIZATIONS: `${baseUrl}/admin-organizations`,
	ADMIN_ORGANIZATION_ADD: `${baseUrl}/admin-organization/add`,
	ADMIN_ORGANIZATION_DETAILS: `${baseUrl}/admin-organization/:organizationId`,
	ADMIN_ORGANIZATION_EDIT: `${baseUrl}/admin-organization/:organizationId/edit`,
	ADMIN_PROPERTIES: `${baseUrl}/admin-properties`,
	ADMIN_PROPERTY_ADD: `${baseUrl}/admin-property/add`,
	ADMIN_PROPERTY_DETAILS: `${baseUrl}/admin-property/:propertyId`,
	ADMIN_PROPERTY_EDIT: `${baseUrl}/admin-property/:propertyId/edit`,
	ADMIN_INSTALLED_PRODUCT_ADD: `${baseUrl}/admin-installed-product/add`, // deprecated, redirects to ADMIN_INSTALLED_DEVICE_ADD
	ADMIN_INSTALLED_PRODUCT_EDIT: `${baseUrl}/admin-installed-product/:installedProdId/edit`, // deprecated, redirects to ADMIN_INSTALLED_DEVICE_EDIT
	ADMIN_INSTALLED_PRODUCTS_DETAILS: `${baseUrl}/admin-installed-product/:installedDevId`, // deprecated, redirects to ADMIN_INSTALLED_DEVICES_DETAILS
	ADMIN_INSTALLED_DEVICE_ADD: `${baseUrl}/admin-installed-device/add`,
	ADMIN_INSTALLED_DEVICE_EDIT: `${baseUrl}/admin-installed-device/:installedDevId/edit`,
	ADMIN_INSTALLED_DEVICES_DETAILS: `${baseUrl}/admin-installed-device/:installedDevId`,
	ADMIN_TIERS: `${baseUrl}/admin-tiers`,
	ADMIN_AI_MODELS: `${baseUrl}/admin-ai-models`,
	ADMIN_SHOP_PRODUCT_ADD: `${baseUrl}/admin-shop-product/add`,
	ADMIN_SHOP_PRODUCTS_DETAILS: `${baseUrl}/admin-shop-product/:shopProductId`,
	ADMIN_INTELLIGENCE: `${baseUrl}/intelligence`,
	ADMIN_DEVICE_DETECTIONS: `${baseUrl}/admin-device-detections`,
	ADMIN_DEVICE_DETECTION_ADD: `${baseUrl}/admin-device-detections/add`,
	ADMIN_DEVICE_DETECTION_DETAILS: `${baseUrl}/admin-device-detections/:jobId`,
	EAGLE_EYE: `${baseUrl}/eagle-eye`,
	EE_API_TESTER: `${baseUrl}/ee-api-tester`,
	PROOF_CENTER: `${baseUrl}/properties/:propertyId/proof-center`,
	PROOF_CENTER_SYSTEM_DETAILS: `${baseUrl}/properties/:propertyId/proof-center/:systemName`,
	// A person from an AHJ claims their jurisdiction. The email link opens CLAIM_JURISDICTION_SETUP.
	CLAIM_JURISDICTION: `${baseUrl}/claim`,
	CLAIM_JURISDICTION_SETUP: `${baseUrl}/claim/setup`,
	// Admin screen to review and manage the claims made from CLAIM_JURISDICTION.
	ADMIN_AUTHORITY_CLAIMS: `${baseUrl}/admin/authority-claims`,
	// Path prefix of all Ollie screens. It is not a page: RootRouter redirects it to OLLIE_DASHBOARD.
	OLLIE: `${baseUrl}/ollie`,
	OLLIE_CHAT: `${baseUrl}/ollie/chat`,
	OLLIE_DASHBOARD: `${baseUrl}/ollie/dashboard`,
	OLLIE_DASHBOARD_INSPECTIONS: `${baseUrl}/ollie/dashboard?tab=inspections`,
	OLLIE_INSPECTION_ADD: `${baseUrl}/ollie/inspections/add`,
	OLLIE_EVIDENCE_COLLECTION: `${baseUrl}/ollie/evidence-collection/:jobId`,
	OLLIE_INSPECTION_DETAILS: `${baseUrl}/ollie/inspections/:jobId`,
	PLAN_REVIEW_ADD: `${baseUrl}/ollie/plan-review/add`,
	PLAN_REVIEW_COLLECTION: `${baseUrl}/ollie/plan-review/upload`,
	// Resubmitting adds a submission to an existing project, so the upload screen is
	// keyed by the project, not by the submission it will produce.
	PLAN_REVIEW_COLLECTION_RESUBMIT: `${baseUrl}/ollie/plan-review/upload/:planReviewId`,
	// The project and its submission history.
	PLAN_REVIEW_SUBMISSIONS: `${baseUrl}/ollie/plan-review/:planReviewId`,
	// The compliance report of one submission.
	PLAN_REVIEW_DETAILS: `${baseUrl}/ollie/plan-review/:planReviewId/submission/:jobId`,
	// The same submission reduced to what the applicant has to act on, so the page can
	// be handed to them without the rest of the report around it.
	PLAN_REVIEW_COMMENTS: `${baseUrl}/ollie/plan-review/:planReviewId/submission/:jobId/comments`,
	// The AHJ's own rules container: what every submittal to this jurisdiction is
	// screened against, and the submittal types those rules are scoped to.
	PLAN_REVIEW_RULES: `${baseUrl}/ollie/plan-review/rules`,
	// The jurisdiction's extraction history, and one run's candidates.
	PLAN_REVIEW_EXTRACTIONS: `${baseUrl}/ollie/plan-review/rules/extraction`,
	PLAN_REVIEW_RULES_EXTRACTION: `${baseUrl}/ollie/plan-review/rules/extraction/:extractionId`,
	// Files the authority publishes outside its rules and adopted codes; Ollie reads them in chat.
	PLAN_REVIEW_RESOURCES: `${baseUrl}/ollie/plan-review/resources`,
	PLAN_REVIEW_SUBMISSION_TYPES: `${baseUrl}/ollie/plan-review/submission-types`,
	// What Ollie charges an applicant to pre-screen a plan review with this authority (MWA-788).
	PLAN_REVIEW_FEE_SCHEDULE: `${baseUrl}/ollie/plan-review/fee-schedule`,
	PLAN_REVIEW_CATEGORIES: `${baseUrl}/ollie/plan-review/categories`,
	PLAN_REVIEW_CODES: `${baseUrl}/ollie/plan-review/codes`,
	PLAN_REVIEW_CODE_IMPORTS: `${baseUrl}/ollie/plan-review/code-imports`,
	PLAN_REVIEW_CODE_IMPORT: `${baseUrl}/ollie/plan-review/code-imports/:importId`,
	BOUNDARY_AUTHORITY_PROPOSALS: `${baseUrl}/ollie/boundary-authorities`,
	BOUNDARY_LAYERS: `${baseUrl}/admin-boundary-layers`,
	// Pre-rebrand prefix, deprecated. Brief emails, bookmarks and any Doctrine prompt
	// still on the old copy hand out /iris links, so RootRouter redirects the whole
	// subtree onto its OLLIE equivalent instead of 404ing.
	LEGACY_IRIS_PREFIX: `${baseUrl}/iris`,
	LEGACY_IRIS_SUBTREE: `${baseUrl}/iris/*`,
	NOT_FOUND: `${baseUrl}/*`
};

export default routeNames;
